import { render, staticRenderFns } from "./Competition2021Page.vue?vue&type=template&id=d333a026&scoped=true&"
import script from "./Competition2021Page.vue?vue&type=script&lang=js&"
export * from "./Competition2021Page.vue?vue&type=script&lang=js&"
import style0 from "./Competition2021Page.vue?vue&type=style&index=0&id=d333a026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d333a026",
  null
  
)

export default component.exports